export default (target) => String(target).padStart(3, '0');
